import { v4 as uuid } from 'uuid';

export const insertId = <T>(object: T): T & { id: string } => {
  return {
    ...object,
    id: uuid(),
  };
};
